import { QuestionDayTripPlanIsRequest as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-request";

import { usePlanIsRequest } from "./hooks";

export const QuestionPlanIsRequest = () => {
	const { isRequest, onSetIsRequest } = usePlanIsRequest();

	return <Question isRequest={isRequest} onSetIsRequest={onSetIsRequest} />;
};

QuestionPlanIsRequest.displayName = "QuestionPlanIsRequest";
